import { Post } from '../helpers';
import { store } from '@/store/main';
import { CreateCampaignRequest, CreateCampaignResponse } from '@/types/campaign.types';

const CreateCampaign = async (data: CreateCampaignRequest): Promise<CreateCampaignResponse> => {
  const projectId = store.getState().project.workingProject?.event;
  return Post({
    path: '/v3/admin/auth/campaigns',
    body: {
      ...data,
      state: 'draft',
      campaign: {
        ...data.campaign,
        metadata: { ...data.campaign.metadata, ...(projectId ? { project_id: projectId } : {}) },
      },
    },
  });
};

export default CreateCampaign;
